__turbopack_context__.v({
  "buttonsWrapper": "_0Iy8yW_buttonsWrapper",
  "container": "_0Iy8yW_container",
  "expandImageIcon": "_0Iy8yW_expandImageIcon",
  "oaWrapper": "_0Iy8yW_oaWrapper",
});
